import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { AfterHeaderAutoSpacerComponent, HeaderSpacer } from "./spacers";
import React from "react";
import { Maybe } from "../../utils/fp/small-fp-utils";
import { ContentFulComponents } from "@swo/storefront";

export const AutoHeaderSpacer: ReactTFC<{
  componentAfterHeaderTypeName: ContentFulComponents["__typename"] | "custom" | undefined;
}> = props => {
  return typeof props.componentAfterHeaderTypeName !== "undefined" ? (
    <AfterHeaderAutoSpacerComponent componentAfterHeaderTypeName={props.componentAfterHeaderTypeName} />
  ) : (
    <HeaderSpacer />
  );
};
